import { Link } from 'react-router-dom'

const LandingPage = () => {
    return (
        <div className='text-gray-100 flex flex-col h-screen'>
            <header className='mx-6 mt-4 flex justify-between'>
                <Link
                    className='text-[20px] font-light flex gap-2 items-center'
                    to='/signin'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                    </svg> Sign In
                </Link>
            </header>
            {/* main */}
            <main className='p-4 flex-grow'>
                <div className='mt-60 text-4xl text-center'>
                    <h1 className='font-light'>Ticketing System</h1>
                </div>
                <div className='pt-4 text-center text-sm' style={{ width: '90%', margin: '0 auto' }}>
                    <p>
                        A web application that allows to
                        <span className='italic'> Create,</span>
                        <span className='italic'> Assign </span> and
                        <span className='italic'> Manage</span> tickets.
                    </p>
                </div>
                <hr className='mt-2 w-[50%] mx-auto border-gray-100' />
            </main>
            {/* footer */}
            <footer className='p-10 bg-slate-50 gap-[5rem] text-black flex justify-between'>

                <div className='ml-0 md:ml-10'>
                    <Link
                        className='text-2xl underline'
                        to='https://nspace.gitbook.io/react-ticketing/'
                        target='_blank'
                    >Docs

                    </Link>
                    <p>
                        Detail features and API documentation.
                    </p>
                </div>
                <div>

                    Managed by:&nbsp;  <Link
                        className='underline'
                        to='https://ikhsannh.com/'
                        target='_blank'
                        rel='noreferrer'
                    >@ikhsannhuda</Link>


                </div>
            </footer>
        </div>
    )
}



export default LandingPage